import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction'; // Needed for event click
import { AddAppointmentModal } from '../FullCalendar/AddAppointment';
import { EditAppointmentModal } from '../FullCalendar/EditAppointments';
import React, { useState, useEffect } from 'react';
import { fetchAppointmentsByResource, fetchPractitionersByPractices } from '../../api';
import { Col, Container, Row, Button, Form } from 'react-bootstrap';
import { jwtDecode } from 'jwt-decode';


export default function UserSchedule({ userId, refresh }) {
    const [events, setEvents] = useState([]); 
    const [selectedEvent, setSelectedEvent] = useState(null); 
    const [editModalShow, setEditModalShow] = useState(false);
    const [addModalShow, setAddModalShow] = useState(false);
    const [resourcesTitle, setResourcesTitle] = useState();
    const [loggedInUser, setLoggedInUser] = useState();
    const [practiceIds, setPracticeIds] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [resourcesId, setResourcesId] = useState(null);
    const [resourcesName, setResourcesName] = useState(null);

    useEffect(() => {
        async function getEventsAndAvailability() {
            if (!userId) return; 
    
            try {
                // Fetch appointments
                const appointmentsResponse = await fetchAppointmentsByResource(userId);
                console.log(appointmentsResponse)
                const formattedEvents = appointmentsResponse.map(event => ({
                    id: event._id || `event-${Math.random()}`,  // ✅ Ensure a unique ID
                    title: event.title || "Untitled Event",  // ✅ Ensure a valid title
                    startTime: event.startTime,
                    endTime: event.endTime,
                    start: event.start || null,
                    end: event.end || null,
                    daysOfWeek: event.daysOfWeek || null,
                    resourceId: event.resourceId || "unknown-resource", // ✅ Prevent undefined resourceId
                    resourceName: event.resourceName || "Unknown Resource", // ✅ Prevent undefined resourceName
                    practiceId: event.practiceId || "0000", // ✅ Assign a default practiceId
                    extendedProps: {
                        status: event.status || "N/A",
                        patientFirstName: event.patientFirstName || "N/A",
                        patientLastName: event.patientLastName || "N/A",
                        patientEmail: event.patientEmail || "N/A",
                        notes: event.notes || "N/A",
                        serviceId: event.serviceId || "N/A",
                        patientId: event.patientId || "N/A"
                    },
                    color: event.backgroundColor || "#0F3490"
                }));
                
                console.log("Formatted Events (After Fix):", formattedEvents);
                setEvents(formattedEvents);
                
    
                setEvents(formattedEvents); // ✅ Always update state
                console.log("formated events", formattedEvents)
                const token = sessionStorage.getItem('user');
                if (!token) {
                    console.error('No user token found in session storage.');
                    return;
                }
    
                const decoded = jwtDecode(token);
                setPracticeIds(decoded.practice);
                
                const practitionersResponse = await fetchPractitionersByPractices(decoded.practice);
                setResourcesTitle(practitionersResponse);
    
            } catch (error) {
                console.error("Error fetching data:", error.message);
            }
        }
    
        getEventsAndAvailability(); // 🔹 Fetch every time component renders
    }, [userId, refresh]); // ✅ Ensure it refetches when switching back to schedule
    

    // ✅ Ensure `setEvents` completed before proceeding
    useEffect(() => {
        if (events.length > 0) {
            console.log("Events updated in state:", events);
        }
    }, [events, refresh]); // ✅ Runs only when `events` is updated

    

    const handleEventClick = (clickInfo) => {
        setSelectedEvent({
            id: clickInfo.event._def.publicId || "N/A",
            title: clickInfo.event.title || "N/A",
            status: clickInfo.event.extendedProps.status || "N/A",
            patientFirstName: clickInfo.event.extendedProps.patientFirstName || "N/A",
            patientLastName: clickInfo.event.extendedProps.patientLastName || "N/A",
            patientId: clickInfo.event.extendedProps.patientId || "N/A",
            patientEmail: clickInfo.event.extendedProps.patientEmail || "N/A",
            notes: clickInfo.event.extendedProps.notes || "N/A",
            start: clickInfo.event.startStr || "N/A",
            end: clickInfo.event.endStr || "N/A",
            resourceId: userId || "N/A", 
            resourceName: clickInfo.event._def.resourceIds
            ? resourcesTitle.find(r => r.id === userId)?.title || "N/A"
            : "N/A", // ✅ Extract `resourceName` from `resourcesTitle`
            practiceId: clickInfo.event.extendedProps.practiceId || "N/A",
            serviceId: clickInfo.event.extendedProps.serviceId || "N/A",
        });
        const foundResource = resourcesTitle.find(resource => resource.id === userId);
        console.log("selectedEvent", selectedEvent);
        console.log("clickInfo", clickInfo);
        if (!foundResource) {
            console.warn(`No resource found for userId: ${userId}`);
        }
    
        setResourcesId(userId); 
        setResourcesName(foundResource?.title || "Unknown"); // ✅ Store the resource name
    };

    useEffect(() => {
      if (selectedEvent && selectedEvent.resourceId !== "N/A")  {
        
        setEditModalShow(true);
        console.log(selectedEvent)
      }
    }, [selectedEvent]);

    const dayClickAction = (info) => {
        setSelectedDate(info.dateStr); // Capture the clicked date
        console.log("info", info);
    
        // Find the resource (therapist) by `userId`
        const foundResource = resourcesTitle.find(resource => resource.id === userId);
    
        if (!foundResource) {
            console.warn(`No resource found for userId: ${userId}`);
        }
    
        setResourcesId(userId); 
        setResourcesName(foundResource?.title || "Unknown"); // ✅ Store the resource name
        setAddModalShow(true); // Show the modal
    };
    

    const handleAddEvent = (newEvent) => {
        setEvents((prevEvents) => [...prevEvents, newEvent]); // Add the new event to the existing events
    };

    return (
        <div className="pt-1 d-flex">
            {/* Calendar */}
            <Col md={12}>
                <div className="container d-flex flex-column">
                    <FullCalendar
                    schedulerLicenseKey="0328351339-fcs-1748930365"
                    key={`calendar-${userId}-${refresh}-${events.length}`}
                        plugins={[timeGridPlugin, dayGridPlugin, interactionPlugin]}
                        nowIndicator={true}
                        businessHours={false}
                        slotDuration={'00:30:00'}
                     
                        slotMinTime={'06:00:00'}
                        slotMaxTime={'20:00:00'}
                        initialView="timeGridDay"
                        height="auto"
                        views={{
                            customFourDayView: {
                              type: "timeGrid",
                              duration: { days: 7 }, 
                              buttonText: "7 DAYS", 
                            },
                          }}
                        buttonText={{
                            today: "TODAY",
                            month: "MONTH",
                            week: "WEEK",
                            day: "DAY",
                          }}
                        headerToolbar={{
                            left: "prev,next today",
                            center: "title",
                            right: "timeGridDay,customFourDayView",
                          }}
                          events={events.length > 0 ? events : []}
                        eventClick={handleEventClick}
                        editable={true}
                        dateClick={dayClickAction}
                    />
                </div>
            </Col>

           {/* Event Details */}
           {/* <Col md={6}>
                <Container className="container pt-3 bg-white shadow-sm border pb-3 mb-3 me-1 w-100 position-relative">
                    <Row className="align-items-center mb-3">
                        <Col>
                            <h5 className="text-primary fw-normal text-center">Event Details</h5>
                        </Col>
                        <Col xs="auto">
                            <Button variant="" size="sm" onClick={() => setAddModalShow(true)}>
                                <i className="fas fa-edit fs-6 text-primary"></i>
                            </Button>
                        </Col>
                    </Row> */}

                    {/* Display Event Details */}
                 {/*   <Col md={12} className="mb-3">
                        <div className="p-3">
                            <Row className="mb-2 align-items-center">
                                <Col md={4} className="text-end pe-2">
                                    <Form.Label className="fw-bold">Title:</Form.Label>
                                </Col>
                                <Col md={8}>
                                    <Form.Label>{selectedEvent?.title || "No Event Selected"}</Form.Label>
                                </Col>
                            </Row>

                            <Row className="mb-2 align-items-center">
                                <Col md={4} className="text-end pe-2">
                                    <Form.Label className="fw-bold">Status:</Form.Label>
                                </Col>
                                <Col md={8}>
                                    <Form.Label>{selectedEvent?.status || "N/A"}</Form.Label>
                                </Col>
                            </Row>

                            <Row className="mb-2 align-items-center">
                                <Col md={4} className="text-end pe-2">
                                    <Form.Label className="fw-bold">Patient Name:</Form.Label>
                                </Col>
                                <Col md={8}>
                                    <Form.Label>{selectedEvent ? `${selectedEvent.patientFirstName} ${selectedEvent.patientLastName}` : "N/A"}</Form.Label>
                                </Col>
                            </Row>

                            <Row className="mb-2 align-items-center">
                                <Col md={4} className="text-end pe-2">
                                    <Form.Label className="fw-bold">Patient Email:</Form.Label>
                                </Col>
                                <Col md={8}>
                                    <Form.Label>{selectedEvent?.patientEmail || "N/A"}</Form.Label>
                                </Col>
                            </Row>

                            <Row className="mb-2 align-items-center">
                                <Col md={4} className="text-end pe-2">
                                    <Form.Label className="fw-bold">Notes:</Form.Label>
                                </Col>
                                <Col md={8}>
                                    <Form.Label>{selectedEvent?.notes || "N/A"}</Form.Label>
                                </Col>
                            </Row>

                            <Row className="mb-2 align-items-center">
                                <Col md={4} className="text-end pe-2">
                                    <Form.Label className="fw-bold">Start Time:</Form.Label>
                                </Col>
                                <Col md={8}>
                                    <Form.Label>{selectedEvent?.start || "N/A"}</Form.Label>
                                </Col>
                            </Row>

                            <Row className="mb-2 align-items-center">
                                <Col md={4} className="text-end pe-2">
                                    <Form.Label className="fw-bold">End Time:</Form.Label>
                                </Col>
                                <Col md={8}>
                                    <Form.Label>{selectedEvent?.end || "N/A"}</Form.Label>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Container>
            </Col> */}
            {selectedEvent && (
            <EditAppointmentModal 
                event={selectedEvent}
                show={editModalShow}
                resources={resourcesTitle}
                onHide={() => setEditModalShow(false)} 
            />
            )}
            {selectedDate && (
             <AddAppointmentModal
                show={addModalShow} // Control modal visibility
                onHide={() => setAddModalShow(false)} // Close modal handler
                selectedDate={selectedDate} // Pass selected date to modal
                resourcesId={userId} // Pass resourceId to modal
                resourcesName={resourcesName} // Pass resourceName to modal
                onSave={handleAddEvent} // Save event handler
                events={events} // Pass events to modal
            />
            )}
        </div>
    );
}
